<template>
  <div id="app">
    <inscripcion></inscripcion>
  </div>
</template>

<script>
import inscripcion from "./components/inscripcion";

export default {
  name: 'App',
  components: {inscripcion}
}
</script>

<style>
body {
 background-image: url("assets/img/background_index.png");
}
</style>
